export class RTCSessionError extends Error
{
	constructor(message: string)
	{
		super(message);

		this.name = 'RTCSessionError';

		if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
		{
			// @ts-ignore
			Error.captureStackTrace(this, RTCSessionError);
		}
		else
		{
			this.stack = (new Error(message)).stack;
		}
	}
}

export class RTCError extends Error
{
	private errorCode:number;
	constructor(message:string, errorCode:number) {
		super(message);
		this.errorCode = errorCode;
		this.name = 'RTCError';
		if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
		{
			// @ts-ignore
			Error.captureStackTrace(this, RTCError);
		}
		else
		{
			this.stack = (new Error(message)).stack;
		}
	  }
}